import React from "react";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Paper, Typography } from "@mui/material";
import clsx from "clsx";
import { updateMultiUpload } from "../../../reducers/configurator/configuratorSlice";

const PREFIX = "MultiUploadDialogContent";

const classes = {
  root: `${PREFIX}-root`,
  topExplanationText: `${PREFIX}-topExplanationText`,
  multiUploadExplanation: `${PREFIX}-multiUploadExplanation`,
  marginBottom: `${PREFIX}-marginBottom`,
  imagesSlider: `${PREFIX}-imagesSlider`,
  multiUploadImage: `${PREFIX}-multiUploadImage`,
  currentSelection: `${PREFIX}-currentSelection`,
};

const MultiUploadDialogContentContainer = styled("div")(({ theme }) => {
  return {
    [`& .${classes.root}`]: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      marginBottom: "1rem",
    },
    [`& .${classes.topExplanationText}`]: {
      display: "flex",
      flexDirection: "column",
      width: "90%",
      marginBottom: "2rem",
    },
    [`& .${classes.multiUploadExplanation}`]: {
      textAlign: "center",
    },
    [`& .${classes.marginBottom}`]: {
      marginBottom: "1rem !important",
    },
    [`& .${classes.imagesSlider}`]: {
      backgroundColor: "#424242",
      display: "flex",
      padding: "10px",
      width: "95vw",
      overflowX: "auto",
      height: "150px",
      [theme.breakpoints.between("xs", "sm")]: {
        width: "90vw",
      },
      "&::-webkit-scrollbar": {
        width: "5px",
        height: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "rgb(181 154 79 / 58%)",
        borderRadius: "10px",
      },
    },
    [`& .${classes.multiUploadImage}`]: {
      height: "125px",
      marginRight: "1rem",
    },
    [`& .${classes.currentSelection}`]: {
      border: `2px solid ${theme.palette.primary.main}`,
      opacity: "0.5",
    },
  };
});

const MultiUploadDialogContent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const multiUpload = useSelector((state) => state.configurator.multiUpload);

  return (
    <MultiUploadDialogContentContainer>
      <div className={classes.root}>
        <div className={classes.topExplanationText}>
          <Typography
            variant="body1"
            className={clsx(
              classes.multiUploadExplanation,
              classes.marginBottom
            )}
          >
            {t("configurator.multiUploadExplanation")}
          </Typography>
          <Typography
            variant="body1"
            className={classes.multiUploadExplanation}
          >
            {t("configurator.multiUploadExplanation2")}
          </Typography>
        </div>
        <Paper elevation={4} className={classes.imagesSlider}>
          {multiUpload.files.map((file, index) => {
            const myBlob = URL.createObjectURL(file);
            return (
              <div key={`multi-upload-file-${index + 1}`}>
                <img
                  src={myBlob}
                  alt={`multi-upload-file-${index + 1}`}
                  className={clsx(
                    classes.multiUploadImage,
                    multiUpload.activeFile?.name === file.name
                      ? classes.currentSelection
                      : ""
                  )}
                  onClick={() =>
                    dispatch(updateMultiUpload({ activeFile: file }))
                  }
                />
              </div>
            );
          })}
        </Paper>
      </div>
    </MultiUploadDialogContentContainer>
  );
};

export default MultiUploadDialogContent;
